import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";

/**
 * PrimaryButton constant ( function component used as generic primary button )
 *
 * @exports constant
 * @param {*} { ...props }
 * @returns HTML object
 */

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "16px",
    paddingRight: "20px",
    paddingBottom: "16px",
    paddingLeft: "10px",
    textAlign: "center",
  },
  typography: {
    fontSize: "12px",
    fontWeight: 500,
    whiteSpace: "pre-line",
    fontFamily: "Mulish",
    textAlign: "center"
    // Backend messages with /n (new line) are valid with this style.
  },
}));

const ErrorBoxUko = ({ ...props }) => {
  const { value, appName, styles } = props;
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Box
      style={{
        marginTop: -16
      }}
    >
      {!appName && (<br />)}
      <Box
        className={classes.root}
        style={{
          backgroundColor: styles?.backgroundColor ?? theme.palette.error.main,
          borderRadius: styles?.borderRadius || "8px",
          border: styles?.borderColor ? `1px solid ${styles?.borderColor}`: '',
        }}
      >
        <Typography
          className={classes.typography}
          style={{
            color: styles?.color ?? theme.palette.error.typographyColor,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default ErrorBoxUko;
